// extracted by mini-css-extract-plugin
module.exports = {"text-field":"text-field--xydWO","textField":"text-field--xydWO","email":"email--wsG5O","tel":"tel--iJI6R","field":"field--Rryfe"};